import { MasterAPIService } from "@app/services/Methods/api";
import {
    BranchInitialDataResponse,
    VersionControlDetailResponse,
    VersionControlResponse,
} from "@app/types/API.types";
import { AddBranchDeploymentPayload, VersionControlPayload } from "@app/types/VersionControl";

export const getVersionControlData = (
    name?: string,
    pageNumber?: number,
    pageSize?: number,
    sortBy?: string,
    sortOrder?: number,
) => {
    const queryParams = [
        name ? `name=${name}` : "",
        pageNumber ? `pageNumber=${pageNumber}` : "",
        pageSize ? `pageSize=${pageSize}` : "",
        sortBy ? `sortBy=${sortBy}` : "",
        sortOrder !== undefined ? `sortOrder=${sortOrder}` : "",
    ]
        .filter(Boolean)
        .join("&");

    return MasterAPIService.get<VersionControlResponse>(
        `/AksDeployment/GetBranchForView?${queryParams}`,
    );
};

export const getVersionByID = (installationId: string) =>
    MasterAPIService.get<VersionControlDetailResponse>(
        `/AksDeployment/GetBranchForView/${installationId}`,
    );

export const updateVersion = (data: VersionControlPayload) =>
    MasterAPIService.patch("/AksDeployment", data);

export const getBranchInitialData = () =>
    MasterAPIService.get<BranchInitialDataResponse>("/AksDeployment/GetBranchforInitialSetup");

export const insertVersion = (data: AddBranchDeploymentPayload) =>
    MasterAPIService.post("/AksDeployment", data);

export const generateDownloadLink = () =>
    MasterAPIService.post("/AksDeployment/generate-download-link");

export const initiateDownloadLink = () =>
    MasterAPIService.get("/AksDeployment/InitiateDownloadLink");
